export default __webpack_public_path__ + "static/media/img4.3c6c6b67.png";